import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { appKillFunc } from '../../../utils/utilityEtc';

function HeaderButton({
  buttons,
  action
}) {
  const history = useHistory();

  const handleClick = useCallback((path) => {
    if (path) {
      history.push(path);
    } else {
      if (action === 'goBack') {
        history.goBack();
      } else {
        appKillFunc();
      }
    }
  }, []);

  return (
    <>
      {
        buttons.map((item, index) => (
          <button
            key={index}
            className={item.cs}
            type="button"
            onClick={() => handleClick(item.path)}
          >
            <img src={`${process.env.PUBLIC_URL}/${item.img}`} alt="" />
          </button>
        ))
      }
    </>
  );
}

export default HeaderButton;